/**
 * Header interactions use event delegation so the browser does not have to
 * upgrade and measure the whole header subtree during the critical render.
 */
const header = document.querySelector('header-component');

if (header) {
  const overlay = header.querySelector('[data-ref="mobile-menu-overlay"]');
  const menuToggle = header.querySelector('[data-ref="menu-toggle"]');
  const menuClose = header.querySelector('[data-ref="menu-close"]');

  const openMobileMenu = () => {
    if (!overlay) return;

    overlay.classList.remove('is-closing');
    overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    window.setTimeout(() => menuClose?.focus(), 150);
  };

  const closeMobileMenu = () => {
    if (!overlay || !overlay.classList.contains('is-open')) return;

    overlay.classList.add('is-closing');
    window.setTimeout(() => {
      overlay.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
      menuToggle?.focus();
    }, 125);
  };

  header.addEventListener('click', (event) => {
    if (event.target.closest('[data-ref="menu-toggle"]')) {
      openMobileMenu();
      return;
    }

    if (event.target.closest('[data-ref="menu-close"]') || event.target === overlay) {
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu();
  });

  // Sticky state only affects the transparent home-page header. Avoid all
  // geometry reads and observers on regular product and collection pages.
  if (header.classList.contains('header--transparent') && header.classList.contains('header--sticky')) {
    const updateStickyState = () => {
      header.dataset.stickyState = window.scrollY > 20 ? 'active' : 'inactive';
    };

    updateStickyState();
    window.addEventListener('scroll', updateStickyState, { passive: true });
  }
}
